export default {
    state: {
        aonContext: null,
        aonProduct: null,
    },
    getters: {
        getAonContext: state => payload => state.aonContext,
        getAonProduct: state => payload => state.aonProduct,
        getAonProductPrice: state => payload =>
            state.aonProduct && state.aonProduct.prices && state.aonProduct.prices.length > 0
                ? state.aonProduct.prices[0].price / 100 // Stripe for some reason gives price*100
                : 79,
    },
    mutations: {
        setAonContext(state, aonContext) {
            state.aonContext = aonContext;
        },
        setAonProduct(state, aonProduct) {
            state.aonProduct = aonProduct;
        },
    },
};
